module.exports = __webpack_public_path__ + "static/img/16.fabe23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/16.png
// module id = Qe2a
// module chunks = 1